import React from 'react';

import { LetterTypes } from '../generator/types';
import { getLetterTypeLabel } from '../generator/utils';

import {
  button,
  modalBackdrop,
  modalContainer,
  primaryButton,
} from './drawerStyles';

export interface DiscardConfirmModalProps {
  pendingLetterType: LetterTypes | null;
  onConfirm: () => void;
  onCancel: () => void;
}

export const DiscardConfirmModal = ({
  pendingLetterType,
  onConfirm,
  onCancel,
}: DiscardConfirmModalProps) => {
  if (!pendingLetterType) return null;
  const targetLabel = getLetterTypeLabel(pendingLetterType);
  return (
    <div style={modalBackdrop} onClick={onCancel}>
      <div
        style={{ ...modalContainer, maxWidth: 460 }}
        onClick={e => e.stopPropagation()}
      >
        <div style={{ padding: '22px 24px 12px' }}>
          <h3 style={{ fontSize: 16, fontWeight: 600, marginBottom: 8 }}>
            Discard current letter?
          </h3>
          <p style={{ fontSize: 13, color: '#6B6A62', lineHeight: 1.5 }}>
            You have unsaved edits in the current letter. Opening {targetLabel}{' '}
            will discard them.
          </p>
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            gap: 8,
            padding: '12px 24px 18px',
          }}
        >
          <button type="button" style={button} onClick={onCancel}>
            Cancel
          </button>
          <button type="button" style={primaryButton} onClick={onConfirm}>
            Continue
          </button>
        </div>
      </div>
    </div>
  );
};
